<template>
  <div id="prop-facilities" class="prop-facilities">
    <ul class="facilities">
      <li class="facility reviews" v-if="reviews.length > 0" @click="scrollTo">
         <svg class="svg">
           <use xlink:href='#ico-star'/>
         </svg>
         <p v-if="reviews.length === 1" class="link"> {{reviews.length}} review</p>
         <p v-else class="link"> {{reviews.length}} reviews</p>
      </li>
      <li class="facility floorplan" @click="openFloorPlan" v-if="isFloorPlan">
        <svg class="svg">
          <use xlink:href='#icon-floorplan'/>
        </svg>
        <p>Floorplan</p>
      </li>
      <li class="facility" v-if="isBaths">
         <svg class="svg">
           <use xlink:href='#icon-bath'/>
         </svg>
         <p class="link">{{property.baths}} Bathroom{{parseInt(property.baths) === 1 ? "":"s"}}</p>
      </li>
      <li class="facility" v-if="property.wifi">
         <svg class="svg">
           <use xlink:href='#icon-wifi-v2'/>
         </svg>
         <p class="link">WiFi</p>
      </li>
      <li class="facility" v-if="property.hot_tub">
         <svg class="svg">
           <use xlink:href='#icon-hottub'/>
         </svg>
         <p class="link">Hot tub</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    property: Object,
    reviews: Array,
    isFloorPlan: Boolean,
    floorPlanImage: Number
  },
  computed: {
    isBaths() {
      return this.$props.property.baths > 0 ? true : false
    }
  },
  methods: {
    scrollTo() {
      this.$emit('scrollTo', 'prop-reviews', -20);
      this.$emit('sendTrack', "click-review-button", true)
    },
    openFloorPlan() {
      this.$emit('toggleModal', this.floorPlanImage);
      this.$emit('sendTrack', 'prop-open-floorplan', true);
    }
  }
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.prop-facilities {
  margin: 1.125rem 1.25rem 1.25rem;

  @media #{$desktop} {
    margin: 1.125rem 0 1.25rem;
  }
}

.facilities {
  display: flex;
  flex-wrap: wrap;
  column-gap: .625rem;
  row-gap: .625rem;
  padding-bottom: 1.25rem;
  border-bottom: 1px solid #D9D9D9;
  position: relative;
  z-index: 2;
}

.facility {
  background-color: $col_xlgrey;
  min-height: auto;
  list-style: none;
  transition: .3s;
  display: flex;
  align-items: flex-end;
  padding: 0.5rem 0.625rem 0.5rem 0.625rem;
  border-radius: 1rem;

  &.reviews {
    background: #FF4600;

    .svg {
      fill: $col_white;
    }

    .link {
      color: $col_white;
    }
  }

  &.floorplan {
    cursor: pointer;
    background: #4B4B4B;

    svg {
      width: 1rem;
      height: 1rem;
    }

    p {
      color: $col_white;
    }

    &:hover {
      background: #666565;
    }
  }
  @media #{$desktop} {
    align-items: center;
    &.reviews {
      &:hover{
        transition: .3s;
        cursor: pointer;
        background: #F38E67;
      }
    }
  }
}

.svg {
  width: 1.25rem;
  height: 1.25rem;
  padding-right: .313rem;
  transition: .3s;
}

.link {
  color: $col_black;
  transition: .3s;
  font-size: .875rem;
  line-height: 1.125rem;
  display: block;
  text-decoration: none;
  text-align: center;

  @media #{$desktop} {
    font-size: 1rem;
    line-height: 1rem;
  }
}
</style>